// extracted by mini-css-extract-plugin
module.exports = {"parts-details-title":"parts-details_parts-details-title__SBXRI","parts-details-title_mobile":"parts-details_parts-details-title_mobile__jAC78"};